import { call, put, takeLatest, all, select } from 'redux-saga/effects';
import { inventory, loading, modal, toast } from '../types';
import scogo_apis from '../scogo_apis';

export function* getAssetsList(action) {
    const { query, limit, page, payload, is_spare } = action.payload;
    let queryParams = { limit, page, is_spare };
    yield put({ type: inventory.SET_ASSETS_FILTER_DATA, payload: action.payload });
    if (payload) queryParams = { ...queryParams, ...payload }
    if (query) queryParams = { ...queryParams, q: query }

    try {
        yield put({ type: inventory.GET_ASSETS_LIST_SUCCESS, payload: [] });
        yield put({ type: loading.SET_ASSETS_LIST_LOADING, payload: true });
        const response = yield call(scogo_apis.inventory.getAssetsList, {}, {}, queryParams);
        if (response.status === 200) {
            yield put({ type: inventory.GET_ASSETS_LIST_SUCCESS, payload: response.data });
        } else {
            yield put({ type: inventory.GET_ASSETS_LIST_FAILURE, payload: response.data });
        }
    } catch (error) {
        yield put({ type: inventory.GET_ASSETS_LIST_FAILURE, payload: error });
    } finally {
        yield put({ type: loading.SET_ASSETS_LIST_LOADING, payload: false });
    }
}

export function* createNewAsset(action) {
    const { payload, formName, onSuccess = () => { }, refreshAssetList = true, additionalProps } = action.payload
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.inventory.postAssetsList, {}, {}, {}, payload)
        if (response.status === 201) {
            if (refreshAssetList) yield put({ type: inventory.REFRESH_ASSETS_REQUEST });
            if (additionalProps && ['create_ticket_form', 'update_rma_form'].includes(additionalProps.source)) {
                yield put({ type: inventory.UPDATE_CREATED_ASSET_IN_STORE, payload: { asset: response.data, key: additionalProps.key } });
            }
            if (response.data.code === 400) {
                yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: Array.isArray(response.data.messages) ? response.data.messages[0] : response.data.messages || 'Something Went Wrong!!' } });
            } else {
                yield put({ type: modal.CLOSE_MODAL })
                yield put({ type: toast.SEND_TOAST, payload: { message: 'Asset created successfully', status: 'success' } })
            }
            onSuccess(response.data)
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: Array.isArray(response.data.messages) ? response.data.messages[0] : response.data.messages || 'Something Went Wrong!!' } });
        }
    } catch (err) {
        console.log('err:', err);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: Array.isArray(err.response.data.messages) ? err.response.data.messages[0] : err.response.data.messages || 'Something Went Wrong!!' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}
export function* getAssetTypeList(action) {
    const { org_id } = action.payload
    try {
        let response = yield call(scogo_apis.inventory.getAssetTypeList, {}, {}, { org_id }, {})

        if (response.status === 200) {
            yield put({ type: inventory.GET_ASSET_TYPE_LIST_REQUEST_SUCCESS, payload: response?.data })
        }
    } catch (err) { }
}
export function* addNewAssetType(action) {
    const { payload, formName, append = true } = action.payload
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        let response = yield call(scogo_apis.inventory.postAssetTypeList, {}, {}, {}, payload)

        if (response.status === 201) {
            yield put({ type: modal.CLOSE_MODAL });
            yield put({ type: toast.SEND_TOAST, payload: { message: response.data.message || 'Asset type created successfully', status: 'success' } })
            let createdAssetType = response.data ? { id: response.data.id, label: response.data.title, key: response.data.id, assetType: response.data, value: response.data.id, fields: response.data.additional_fields } : null;
            yield put({ type: inventory.ADD_NEW_ASSET_TYPE_REQUEST_SUCCESS, payload: { data: createdAssetType } });
        }
    } catch (err) {
        console.log('err:', err)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: err?.response?.data?.messages[0] || 'Something Went Wrong!!' } });
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
}
export function* updateAssets(action) {
    const {
        payload,
        id,
        formName,
        onSuccess = () => { },
        onError = () => { },
        closeModal = true,
        refresh = true,
        showToast = true,
    } = action.payload
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        let response = yield call(scogo_apis.inventory.updateAssetsList, {}, { id }, {}, payload)
        if (response.status === 200) {
            if (closeModal) yield put({ type: modal.CLOSE_MODAL })
            if (refresh) yield put({ type: inventory.REFRESH_ASSETS_REQUEST });
            if (showToast) yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'Asset updated successfully' } })
            onSuccess(response.data)
        } else {
            throw new Error(response?.data?.messages?.[0] || 'Unable to update asset');
        }
    } catch (err) {
        console.log('err:', err);
        onError(err)
        if (showToast) yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: err?.response?.data?.messages[0] || 'Something Went Wrong!!' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}

export function* refreshAssets(action) {
    try {
        const payload = yield select(state => state.inventory.assetsFilterData);
        yield put({ type: inventory.GET_ASSETS_LIST_REQUEST, payload });
    } catch (error) {
        console.log('error:', error)
    }
}


export function* generateAssetsBarcode(action) {
    const { payload, formName } = action.payload;
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });

    try {
        const response = yield call(scogo_apis.inventory.generateTags, {}, {}, {}, payload);
        if (response.status === 201) {
            yield all([yield put({ type: modal.CLOSE_MODAL }), yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'Assets QR Codes Generated' } })]);
            if (response?.data?.downloads && Array.isArray(response.data.downloads) && response.data.downloads.length > 0) {
                response.data.downloads.forEach(download => {
                    window.open(download, '_blank');
                });
            }
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response.data.messages[0] || 'Oops Something went wrong' } });
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
}

export function* getAssetHistoryById(action) {
    const { id } = action.payload;
    yield put({ type: loading.ASSEST_HISTORY_LOADING, payload: true });
    try {
        const response = yield call(scogo_apis.inventory.assetHistory, {}, { id }, {}, {});
        if (response.status === 200) {
            yield put({ type: inventory.GET_INVENTORY_HISTORY_BY_ID_SUCCESS, payload: { id, data: response.data } })
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response.data.messages[0] || 'Oops Something went wrong' } });
    }
    yield put({ type: loading.ASSEST_HISTORY_LOADING, payload: false });
}

export function* getAssetFilterList(action) {
    const { filter_labels, is_spare = false, q, formName } = action.payload;
    const queryParams = { is_spare, filter_labels };
    if (q) queryParams.q = q;
    if (q && formName) {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
    }
    try {
        const response = yield call(scogo_apis.inventory.assetsFilterList, {}, {}, queryParams);
        if (response.status === 200) {
            yield put({ type: inventory.GET_ASSET_FILTER_LIST_SUCCESS, payload: { data: response.data.data, q } });
        }
    } catch (err) {
        console.log(err)
    } finally {
        if (q && formName) {
            yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
        }
    }
}


export default function* assetsSaga() {
    yield takeLatest(inventory.GET_ASSETS_LIST_REQUEST, getAssetsList);
    yield takeLatest(inventory.CREATE_NEW_ASSET_REQUEST, createNewAsset);
    yield takeLatest(inventory.GET_ASSET_TYPE_LIST_REQUEST, getAssetTypeList);
    yield takeLatest(inventory.ADD_NEW_ASSET_TYPE_REQUEST, addNewAssetType);
    yield takeLatest(inventory.UPDATE_ASSET_REQUEST, updateAssets);
    yield takeLatest(inventory.REFRESH_ASSETS_REQUEST, refreshAssets);
    yield takeLatest(inventory.GENERATE_ASSETS_BARCODE_REQUEST, generateAssetsBarcode);
    yield takeLatest(inventory.GET_INVENTORY_HISTORY_BY_ID_REQUEST, getAssetHistoryById);
    yield takeLatest(inventory.GET_ASSET_FILTER_LIST_REQUEST, getAssetFilterList);
}
